export default __webpack_public_path__ + "static/media/25101303.f37c5077.jpg";